// Leave this file here, so it's reachable from md (styleguidist)
import * as React from 'react';
import { Provider } from 'react-redux'

import store from 'store';

const Store: React.StatelessComponent<{}> = (props) => {
    return (
        <Provider store={store}>
            {props.children}
        </Provider>
    );
}

export default Store;